import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { themeNames } from '@upgrade/themes';
import { Direction } from './constants';
import UniversalLogo from './theme/universal_credit';
import UpgradeLogo from './theme/upgrade';
const tNames = Object.values(themeNames);
const validTheme = tNames.includes.bind(tNames);
const Logos = {
  upgrade: UpgradeLogo,
  universal_credit: UniversalLogo,
  dark: UpgradeLogo
};
const Logo = ({
  name,
  direction = Direction.horizontal,
  outline = false,
  color,
  viewBox,
  width,
  height,
  ...props
}) => {
  const theme = useTheme();
  const themeName = name || theme.name;
  const logoThemeName = validTheme(themeName) ? themeName : 'upgrade';
  const LogoComponent = Logos[logoThemeName];
  return /*#__PURE__*/React.createElement(LogoComponent, _extends({
    direction,
    color,
    viewBox,
    width,
    height,
    outline
  }, props));
};
Logo.propTypes = {
  direction: PropTypes.oneOf(Object.keys(Direction)),
  color: PropTypes.string,
  outline: PropTypes.bool,
  viewBox: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.oneOf(tNames)
};
export default Logo;
//# sourceMappingURL=index.js.map